var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.haveData)?_c('div',[_c('h3',[_vm._v("Transition Risk")]),_c('br'),_vm._l((_vm.metrics),function(metric){return _c('carbon-table',{attrs:{"metric":metric}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }